// extracted by mini-css-extract-plugin
module.exports = {"rubels":"OnlineGroupCard_rubels__29Oaj","content":"OnlineGroupCard_content__BvDbw","card":"OnlineGroupCard_card__y1m0X"};